var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_array-from-iterable.js
// module id = 557
// module chunks = 168707334958949